import { useEffect, useState } from 'react';
import { Select } from '@shared/widgets/select';
import { TransactionStatusEnum } from '@shared/api/rest/transactions';
import { $transactionStore, $paymentStore, $initialCurrenciesAvailableStore } from '@lib/store';
import { useUnit } from 'effector-react';
import { AccountType } from '@shared/api/rest/accounts';
import { DepositPaymentStatusEnum } from '@shared/api/rest/payment';
import { PaymentTable } from './paymentTable';
import { TransactionTable } from './transactionTable';
import { SearchInput } from '@shared/widgets';

const STATUSES = Object.entries(TransactionStatusEnum).map((x) => ({ label: x[1], value: x[1] }));
const PAYMENT_STATUSES = Object.entries(DepositPaymentStatusEnum).map((x) => ({ label: x[0], value: x[1] }));

interface ListProps {
  accountIds?: number[];
  search?: boolean;
  filter?: boolean;
  accountType?: AccountType;
}

export const List = (props: ListProps) => {
  const currenciesAvailableStore = useUnit($initialCurrenciesAvailableStore.store);
  const transactionStore = useUnit($transactionStore.store);
  const paymentStore = useUnit($paymentStore.store);

  const [searchText, setSearchText] = useState<string>('');
  const [countItemPage, setCountItemPage] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currency, setCurrency] = useState<string>();
  const [transactionStatus, setTransactionStatus] = useState<TransactionStatusEnum>();
  const [paymentStatus, setPaymentStatus] = useState<DepositPaymentStatusEnum>();

  useEffect(() => {
    setCurrentPage(1);
    setTransactionStatus(undefined);
    setPaymentStatus(undefined);
    setCountItemPage(10);
  }, [props.accountType]);

  useEffect(() => {
    if (props.accountType === AccountType.Card) {
      $transactionStore.events.update({
        Status: transactionStatus,
        TextSearch: searchText,
        Currency: currency,
        Count: countItemPage,
        FromIndex: (currentPage - 1) * countItemPage,
        AccountIds: props.accountIds,
      });
    }
    if (props.accountType === AccountType.Payment && props.accountIds && props.accountIds.length > 0) {
      $paymentStore.events.getPaymentsByAccounts({
        AccountIds: props.accountIds,
        Currency: currency,
        SearchText: searchText,
        Count: countItemPage,
        FromIndex: (currentPage - 1) * countItemPage,
        Status: paymentStatus,
      });
    }
  }, [currentPage, countItemPage, searchText, currency, transactionStatus, paymentStatus, props.accountType, props.accountIds]);

  return (
    <>
      {(props.search || props.filter) && (
        <div className='flex gap-12'>
          {props.search && <SearchInput className='w-96' value={searchText} onChange={setSearchText} />}
          {props.filter && (
            <div className='flex gap-3 ml-auto'>
              <Select
                className='min-w-[160px]'
                items={currenciesAvailableStore.data}
                nullValue={{ isEnable: true, text: 'All currencies' }}
                value={currency}
                onChange={setCurrency}
              />
              {props.accountType === AccountType.Card && (
                <Select
                  className='min-w-[140px]'
                  items={STATUSES}
                  value={transactionStatus}
                  nullValue={{ isEnable: true, text: 'All statuses' }}
                  onChange={setTransactionStatus}
                />
              )}
              {props.accountType === AccountType.Payment && (
                <Select
                  className='min-w-[140px]'
                  items={PAYMENT_STATUSES}
                  value={paymentStatus}
                  nullValue={{ isEnable: true, text: 'All statuses' }}
                  onChange={setPaymentStatus}
                />
              )}
            </div>
          )}
        </div>
      )}
      {props.accountType === AccountType.Card ? (
        <TransactionTable
          isLoading={transactionStore.loading}
          data={transactionStore.data.data}
          currentPage={currentPage}
          totalItemCount={transactionStore.data.total}
          countItemPage={countItemPage}
          onChangePage={setCurrentPage}
          onChangeCountItemPage={setCountItemPage}
        />
      ) : (
        <PaymentTable
          isLoading={paymentStore.loading}
          data={paymentStore.data.data}
          currentPage={currentPage}
          totalItemCount={paymentStore.data.total}
          countItemPage={countItemPage}
          onChangePage={setCurrentPage}
          onChangeCountItemPage={setCountItemPage}
        />
      )}
    </>
  );
};
